module.exports = {};



// WEBPACK FOOTER //
// webpack://pdfmake/node_modules/core-js/internals/iterators.js